import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, options, references } from '@apexdesigner/schema-tools';

export const serviceTaskHistory = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    eventType: options([
      { value: 'Created', name: 'Created' },
      { value: 'Claimed', name: 'Claimed' },
      { value: 'Completed', name: 'Completed' },
      { value: 'Error Occurred', name: 'Error Occurred' },
      { value: 'Retry', name: 'Retry' },
    ]).describe('What happened to the task'),

    data: z
      .unknown()
      .nullable()
      .optional()
      .presentAs('json')
      .describe('Additional details about what changed'),

    timestamp: z.coerce
      .date()
      .nullable()
      .optional()
      .describe('When this event occurred'),

    serviceTaskId: z.uuid().hidden().describe('Foreign key to ServiceTask'),

    tenantId: z
      .uuid()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to Tenant'),

    serviceTask: belongsTo('ServiceTask'),

    tenant: references('Tenant'),
  })
  .describe('Records each action taken on a service task')
  .as('ServiceTaskHistory');

export { serviceTaskHistory as serviceTaskHistorySchema };
